const AWS = require('aws-sdk/global')
const dynamodb = require('aws-sdk/clients/dynamodb')
const S3 = require('aws-sdk/clients/s3')

const config = {
  region: 'us-west-1',
  credentials: new AWS.Credentials({
    accessKeyId: process.env.AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.AWS_SECRET_ACCESS_KEY,
  }),
}

const dynamoDbClient = new dynamodb.DocumentClient(config)
// const s3Client = new S3({
//   ...config,
// })

module.exports = dynamoDbClient



// WEBPACK FOOTER //
// ./src/config/aws.js